<template>
  <div v-if="user.id">
    <panel />
  </div>
  <div v-else>
    <front />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Panel from './StartPage'
import Front from './Front'

export default {
  name: 'home',
  components: {
    panel: Panel,
    front: Front
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  }
}
</script>
